export const zh = {
  nav: {
    about: '关于我们',
    services: '服务项目',
    blog: '客户反馈',
    booking: '预约',
  },
  hero: {
    title: '灵性疗愈·心灵觉醒',
    subtitle: '专业灵性疗愈，陪伴您的内在成长之旅',
    description1: '在这里，您将体验到深层次的心灵疗愈与能量平衡。我们致力于帮助每一位来访者找回内心的宁静，重新连接真实的自我，开启灵性成长的旅程。',
    bookNow: '立即预约',
    learnMore: '了解更多',
    bilingual: '双语服务',
  },
  services: {
    title: '疗愈项目',
    subtitle: '专业的灵性疗愈服务，为您的身心灵带来深度滋养与转化',
    pellowah: {
      title: 'PELLOWAH',
      subtitle: 'PELLOWAH 能量疗愈',
      description: 'Pellowah 是一种旨在提升意识、净化能量并带来深层身心平衡的高频能量疗愈系统，侧重于直接连接高维能量，促进个人灵性觉醒，由内而外改变负面信念与情绪模式，常用于改善心理压力和促进整体健康。',
      button: '了解详情',
    },
    umana: {
      title: 'UMANA',
      subtitle: 'UMANA 能量疗愈',
      description: 'UMANA 是一种激活物质身体之上第8-12脉轮的技术，旨在促进成长转变和赋能，是灵魂的充电电池',
      button: '了解详情',
      tag: '热门 开启第8-12脉轮',
    },
    bach: {
      title: '巴赫花精疗愈',
      subtitle: '天然花精能量疗法',
      description: '运用38种天然花精的振动能量，温和而精准地调和负面情绪与心理状态，从根源疗愈情绪失衡，重建内在平静与自信。',
      button: '了解详情',
      tag: '解决情绪问题推荐',
    },
    quantum: {
      title: '量子催眠',
      subtitle: '深度意识探索',
      description: '透过深度催眠引导，连接潜意识与高我智慧，探索前世今生、灵魂使命与人生课题，获得深刻的内在洞见与疗愈转化。',
      button: '了解详情',
      tag: '深度',
    },
    oracle: {
      title: '神谕卡',
      subtitle: '神圣智慧与直觉引导',
      description: '借助神谕卡的神圣智慧与直觉引导，为您当下的生命议题带来清晰的洞见与指引，连接内在智慧，找到前行的方向与力量。',
      button: '了解详情',
      tag: '直觉',
    },
    chakra: {
      title: '脉轮测试',
      subtitle: '能量中心评估与平衡',
      description: '通过系统评估七大脉轮能量状态，精准定位能量阻塞与失衡点，了解身体、情绪与灵性的深层关联，为您量身定制个性化疗愈方案。',
      button: '了解详情',
      tag: '自我认知',
    },
  },
  testimonials: {
    title: '用户评价',
    quote: '这次疗愈体验让我重新找回内心的平静，老师的引导非常专业且温暖。整个过程让我感受到被理解和支持，真的非常感谢。',
    name: '张女士',
    role: '企业高管',
    button: '查看更多评价',
  },
  cta: {
    title: '开启你的疗愈之旅',
    subtitle: '让心灵回归宁静',
    button: '立即预约咨询',
  },
  booking: {
    title: '联络我们',
    subtitle: '通过 WhatsApp 与我们联系，安排您的疗愈时间',
    quickBook: '选择疗愈项目快速预约',
    generalButton: '立即 WhatsApp 预约',
    hint: '点击按钮将自动跳转至 WhatsApp 并填入预约讯息',
    services: ['PELLOWAH', 'UMANA', '巴赫花精疗愈', '量子催眠', '神谕卡', '脉轮测试'],
    whatsappMsg: '你好，我想预约{service}疗愈服务，请问有哪些时间可以安排？',
    whatsappMsgGeneral: '你好，我想预约疗愈服务，请问有哪些时间可以安排？',
  },
  footer: {
    brand: '阳光灵性疗愈',
    description: '我们致力于为每一位寻求心灵成长的朋友提供专业、温暖的灵性疗愈服务。在这里，您将找到属于自己的宁静与力量。',
    address: '地址',
    addressLine1: '新加坡',
    phone: '电话',
    phoneNumber: '+65 9365 1286',
    copyright: '© 2025 阳光灵性疗愈工作室 版权所有',
    privacy: '隐私政策',
    terms: '服务条款',
    sitemap: '网站地图',
  },
  whatsappBooking: {
    title: '立即预约',
    subtitle: '点击下方按钮，通过 WhatsApp 与我们联系，安排您的疗愈时间',
    label: 'WhatsApp 联络',
    button: '通过 WhatsApp 预约',
    hint: '点击后将跳转至 WhatsApp，我们会尽快回复您',
  },
  pellowahDetail: {
    hero: {
      title: 'PELLOWAH',
      subtitle: '佩洛瓦能量疗愈',
      description: '高频灵性能量疗愈，直接连接高我，扩展意识维度，突破内在限制，开启全新的生命视角与灵性觉知。',
    },
    intro: {
      title: '什么是 PELLOWAH',
      content: 'Pellowah 是一种旨在提升意识、净化能量并带来深层身心平衡的高频能量疗愈系统。它由澳大利亚人 Kachina Ma\'an 创立，名称意为"意识的转变"。与传统疗愈不同，Pellowah 侧重于直接连接高维能量，促进个人灵性觉醒，由内而外改变负面信念与情绪模式，常用于改善心理压力和促进整体健康。',
      featuresTitle: 'Pellowah 疗愈的核心特点',
      features: [
        { title: '频率极高', desc: 'Pellowah 直接作用于光体和意识层面，能量频率较传统能量疗法（如 Reiki）更高、更精细。' },
        { title: '不触碰身体', desc: '疗愈师在非接触的情况下进行操作，通过手势引导能量进入个案的能量场。' },
        { title: '由内而外的改变', desc: '强调帮助参与者从心理根源（潜意识、核心信念）上进行改变，不仅是缓解症状，更为了根除精神上的能量阻塞。' },
        { title: '提升觉知', desc: '增强个人对自身思想、情感的觉察能力，从而在日常生活中做出更积极的选择。' },
        { title: '广泛应用', desc: '用于减轻压力、平衡情绪、解除身心疲惫以及寻找灵性成长的方向。' },
      ],
      conclusion: 'Pellowah 适合希望提升生活质量、寻求内心平静或寻求自我觉醒的个体。来自新加坡的疗愈师 Susie 是第一位把 PELLOWAH 疗愈技术引入新加坡的疗愈师。',
    },
    benefits: {
      title: '核心功效',
      benefit1: { title: '意识扩展', description: '打开更高维度的意识通道，提升灵性觉知与直觉力' },
      benefit2: { title: '突破限制', description: '释放深层信念束缚，突破人生瓶颈与成长障碍' },
      benefit3: { title: '可远程疗愈', description: '不受地域限制，可通过远程方式进行疗愈，随时随地接收高频能量' },
      benefit4: { title: '能量平衡', description: '调和身心灵能量场，恢复内在和谐与平静' },
      benefit5: { title: '灵性觉醒', description: '激活灵魂记忆，开启灵性成长与生命转化' },
      benefit6: { title: '情绪释放', description: '温和释放压抑情绪，疗愈内在创伤与痛苦' },
    },
    process: {
      title: '疗愈流程',
      step1: { title: '能量准备', description: '通过冥想与呼吸练习，让身心进入放松状态，准备接收高频能量' },
      step2: { title: '能量传导', description: '疗愈师作为能量通道，将 Pellowah 高频能量传导至您的能量场' },
      step3: { title: '意识扩展', description: '在能量作用下，意识自然扩展，连接高我智慧，获得深刻洞见' },
      step4: { title: '整合沉淀', description: '疗愈后给予时间整合体验，让能量在日常生活中持续发挥作用' },
    },
    suitable: {
      title: '适合人群',
      content: '适合所有寻求灵性成长、意识扩展的朋友，特别是感到人生迷茫、渴望突破现状、希望连接内在智慧的人群。',
      item1: '感到人生迷茫、缺乏方向感，渴望找到生命意义的人',
      item2: '希望突破内在限制与信念束缚，开启新生命视角的人',
      item3: '对灵性成长、意识扩展有强烈渴望的探索者',
      item4: '长期感到能量低落、身心失衡，需要深层调整的人',
    },
    method: {
      title: '疗愈方式',
      step1: { title: '非接触式能量传导', desc: '疗愈师无需触碰身体，通过能量场直接传导高频 Pellowah 能量，过程轻松舒适' },
      step2: { title: '深度冥想引导', desc: '配合呼吸与冥想，引导您进入放松状态，让意识自然扩展，接收高我智慧' },
      step3: { title: '能量整合与反馈', desc: '疗愈结束后进行体验分享与整合，帮助您将能量转化落实到日常生活中' },
    },
    cta: { title: '开启您的意识扩展之旅', button: '立即预约 PELLOWAH', back: '返回服务列表' },
    pricing: {
      title: '服务时长与费用',
      duration: '服务时长',
      price: '服务费用',
      note: '如需了解更多详情或特别安排，欢迎通过 WhatsApp 联系我们',
      items: [
        { duration: '60 分钟', price: 'SGD $150', label: '标准疗愈' },
        { duration: '90 分钟', price: 'SGD $200', label: '深度疗愈' },
      ],
    },
  },
  umanaDetail: {
    hero: {
      title: 'UMANA',
      subtitle: '乌玛纳整合疗愈',
      description: '整合身心灵的深度疗愈系统，透过能量场重新校准，释放深层创伤与情绪模式，恢复生命本源的和谐与完整。',
    },
    intro: {
      title: '什么是 UMANA',
      content: 'Umana 是一种利用体内特定经络来激活物质身体之上的第8-12脉轮的技术，旨在促进成长、转变与赋能，是灵魂的"电池充电"。UMANA 是一个天使语词汇，意为"进化性突破"。它是一种全新的方式，通过开启和进入体内全新的经络系统，在接受疗愈的人身上产生巨大的意识转变。其设计旨在提升意识与成长，并促进更完善的健康、身心平衡与改变体系。这些经络及其对应的脉轮一直存在于人体之中，只是需要通过特定方式激活这些脉轮，以加速整个疗愈过程。这些经络及其所连接的脉轮曾以多种名称为人所知，Umana 以一种简单而深刻的方式将其激活。在激活8-12脉轮的过程中，我们将增强自身的共情能力，同时与所有情境保持超然。之所以使用经络脉轮，是因为它们所激活的脉轮存在于物质身体之外，因此必须借助体内的经络来激活它们。通过 Umana 激活的脉轮，将持续保持激活状态。',
    },
    chakraDiagram: {
      title: '人体12脉轮分布图',
      description: 'UMANA 疗愈激活位于物质身体之外的第8-12脉轮，配合传统第1-7脉轮，共同构成完整的12脉轮能量系统，带来前所未有的意识转变与深层疗愈。',
    },
    superChakras: {
      title: '体外脉轮介绍',
      quote: '脉轮就是精微体中的能量管道，可以吸收和处理本质震动频率更高的能量，让能量被适当的吸收用来改变肉体',
      quoteAuthor: '— Richard Gerber',
      intro: '在平衡开启自己全部脉轮的情况下，激活以下体外脉轮：',
      chakras: [
        { number: '第 8 脉轮', desc: '超越自我和地球维度，灵性智慧和感知力' },
        { number: '第 9 脉轮', desc: '与宇宙连接的能量。开悟的能力潜藏于第九脉轮之中，等待并唤醒并运用于内在与外在的世界' },
        { number: '第 10 脉轮', desc: '第十脉轮开启，个体将开始展现所有前世累积的技能和智慧。在这个脉轮的加持下，机会自然出现，无需设定意图，刻意追求或费力争取，宇宙自会安排' },
        { number: '第 11 脉轮', desc: '这个脉轮承载着能量连接可以让个体显化出更高阶的灵性技能' },
        { number: '第 12 脉轮', desc: '我们与源头的神圣连接，它将带来圆满与合一的感受。这个脉轮使所有维度与实像交融共存，并使其向你敞开，让你能够同时存在并穿梭于各个维度（DIMENSION）与界域（REALM）之中' },
      ],
      susieNote: '新加坡的灵性疗愈师 Susie 是第一个把 Umana 疗愈技术引入新加坡的疗愈师',
      summary: 'UMANA 疗愈激活位于物质身体之外的第8-12脉轮，配合传统第1-7脉轮，共同构成完整的12脉轮能量系统，带来前所未有的意识转变与深层疗愈。',
    },
    benefits: {
      title: '疗愈益处',
      benefit1: { title: '开启并激活人体外第8-12脉轮', description: '释放储存在细胞记忆中的创伤与痛苦，从根源疗愈' },
      benefit2: { title: '巨大意识转变与身心平衡', description: '识别并转化重复出现的负面情绪模式与行为习惯' },
      benefit3: { title: '可用于疗愈地球，疗愈祝福生意或地点的能量场', description: '重新校准能量场，恢复身心灵各层面的和谐与平衡' },
      benefit4: { title: '超越你的看法去看到真相', description: '打通身体、情绪、心智、灵性的连接，实现整体平衡' },
      benefit5: { title: '生命力恢复', description: '激活生命本源能量，提升整体活力与生命质量' },
      benefit6: { title: '内在完整感', description: '重建内在完整性，找回真实自我与生命力量' },
    },
    process: {
      title: '疗愈流程',
      step1: { title: '能量评估', description: '通过能量扫描，识别身心灵各层面的失衡与阻塞' },
      step2: { title: '深层释放', description: '运用 UMANA 技术，释放深层创伤、情绪模式与限制性信念' },
      step3: { title: '能量校准', description: '重新校准能量场，恢复身心灵各层面的和谐与平衡' },
      step4: { title: '整合巩固', description: '整合疗愈体验，建立新的健康模式，巩固疗愈成果' },
    },
    suitable: {
      title: '适合人群',
      content: '适合经历过深层创伤、长期情绪困扰、反复出现负面模式的朋友，以及希望进行全方位身心灵整合与深度疗愈的人群。',
      item1: '16 岁以上',
      item2: '渴望更高层意识觉醒的人',
      item3: '感到身心灵失衡、生命力低落，渴望全面恢复活力的人',
      item4: '希望从根源转化限制性信念，重建内在完整感与自我超越的人',
    },
    method: {
      title: '疗愈方式',
      step1: { title: '面对面，可躺可坐', desc: '需要轻度接触' },
      step2: { title: '可远程 无接触疗愈', desc: '客户需要在一个安静无打扰空间' },
      step3: { title: '可进行多次疗愈，每次疗愈间隔需大于两周时间', desc: '轻度疗愈30分钟，开启第8-10脉轮；深度疗愈60分钟，开启体外全部第8-12脉轮' },
    },
    cta: { title: '开启您的整合疗愈之旅', button: '立即预约 UMANA', back: '返回服务列表' },
    pricing: {
      title: '服务时长与费用',
      duration: '服务时长',
      price: '服务费用',
      note: '如需了解更多详情或特别安排，欢迎通过 WhatsApp 联系我们',
      items: [
        { duration: '30 分钟', price: 'SGD $80', label: '轻度疗愈' },
        { duration: '60 分钟', price: 'SGD $150', label: '深度疗愈' },
      ],
    },
  },
  bachDetail: {
    hero: {
      title: '巴赫花精疗愈',
      subtitle: '天然花精能量疗法',
      description: '运用38种天然花精的振动能量，温和而精准地调和负面情绪与心理状态，从根源疗愈情绪失衡，重建内在平静与自信。',
    },
    intro: {
      title: '什么是巴赫花精',
      content: '巴赫花精疗愈由英国医师爱德华·巴赫博士于1930年代创立，是一种温和而有效的自然疗法。它运用38种精心挑选的野生花卉的振动能量，针对不同的负面情绪状态进行精准调和。用花的能量调节情绪，平衡情绪的同时唤醒内在自愈力',
    },
    benefits: {
      title: '核心功效',
      benefit1: { title: '情绪调和', description: '精准调和焦虑、恐惧、愤怒等38种负面情绪状态' },
      benefit2: { title: '温和疗愈', description: '纯天然能量疗法，无副作用，安全温和' },
      benefit3: { title: '根源疗愈', description: '从情绪根源入手，而非仅仅压抑症状' },
      benefit4: { title: '内在平静', description: '重建内在平静与安宁，提升情绪稳定性' },
      benefit5: { title: '自信重建', description: '疗愈自我怀疑与恐惧，重建内在自信与力量' },
      benefit6: { title: '个性化配方', description: '根据个人情绪状态，定制专属花精配方' },
    },
    process: {
      title: '疗愈流程',
      step1: { title: '情绪评估', description: '通过深入交流，识别当前的情绪状态与内在需求' },
      step2: { title: '配方定制', description: '从38种花精中精准选择，调配专属于您的个性化配方' },
      step3: { title: '服用指导', description: '详细说明花精的服用方法、频率与注意事项' },
      step4: { title: '持续跟进', description: '定期跟进情绪变化，根据需要调整花精配方' },
    },
    suitable: {
      title: '适合人群',
      content: '适合所有经历情绪困扰的朋友，包括焦虑、抑郁、恐惧、愤怒、自我怀疑等情绪问题。特别适合希望采用自然温和方式疗愈情绪的人群。',
      item1: '长期受焦虑、恐惧、抑郁、愤怒等负面情绪困扰的人',
      item2: '面临重大人生转变（失业、分手、丧亲）需要情绪支持的人',
      item3: '儿童、孕妇及对化学药物敏感，希望采用纯天然疗法的人',
      item4: '自我怀疑、缺乏自信，希望重建内在力量与平静的人',
    },
    method: {
      title: '疗愈方式',
      step1: { title: '深度情绪评估咨询', desc: '通过温和的深度交流，全面了解您当前的情绪状态、生活背景与内在需求，建立信任关系' },
      step2: { title: '个性化花精配方调制', desc: '从38种天然花精中精准筛选，为您量身调配专属配方，每瓶配方针对您独特的情绪模式' },
      step3: { title: '持续跟进与调整', desc: '定期追踪情绪变化与疗愈进展，根据实际反应灵活调整花精配方，确保最佳疗愈效果' },
    },
    cta: { title: '开启您的花精疗愈之旅', button: '立即预约巴赫花精', back: '返回服务列表' },
    pricing: {
      title: '服务时长与费用',
      duration: '服务时长',
      price: '服务费用',
      note: '如需了解更多详情或特别安排，欢迎通过 WhatsApp 联系我们',
      items: [
        { duration: '60 分钟', price: 'SGD $120', label: '情绪评估 + 配方' },
        { duration: '30 分钟', price: 'SGD $60', label: '复诊调整' },
      ],
    },
  },
  quantumDetail: {
    hero: {
      title: '量子催眠',
      subtitle: '深度意识探索',
      description: '透过深度催眠引导，连接潜意识与高我智慧，探索前世今生、灵魂使命与人生课题，获得深刻的内在洞见与疗愈转化。',
    },
    intro: {
      title: '什么是量子催眠（QHHT)',
      content: '量子催眠是一种深度催眠技术，它能够帮助您进入深层的潜意识状态，连接高我智慧与灵魂记忆。在这个状态下，您可以探索前世今生的经历，了解灵魂的使命与人生课题，获得关于当前生命困境的深刻洞见。进入Theta波回溯前世由潜意识解答今生困惑',
    },
    benefits: {
      title: '核心功效',
      benefit1: { title: '前世探索', description: '探索前世记忆，了解今生课题的深层根源' },
      benefit2: { title: '灵魂使命', description: '连接高我智慧，了解灵魂使命与人生目的' },
      benefit3: { title: '深层疗愈', description: '释放前世今生的创伤与恐惧，实现深层疗愈' },
      benefit4: { title: '内在洞见', description: '获得关于人生困境的深刻洞见与智慧指引' },
      benefit5: { title: '关系疗愈', description: '了解灵魂契约，疗愈重要关系中的课题' },
      benefit6: { title: '生命转化', description: '从灵魂层面实现转化，找到生命的意义与方向' },
    },
    process: {
      title: '疗愈流程',
      step1: { title: '前期准备', description: '了解您的需求与问题，说明催眠过程与注意事项' },
      step2: { title: '深度放松', description: '通过引导，让身心进入深度放松的催眠状态' },
      step3: { title: '潜意识探索', description: '在催眠状态下，探索前世记忆、灵魂使命与人生课题' },
      step4: { title: '疗愈整合', description: '释放深层创伤，获得洞见，整合催眠体验' },
      step5: { title: '唤醒分享', description: '温和唤醒，分享体验，解答疑问，给予后续指导' },
    },
    suitable: {
      title: '适合人群',
      content: '适合对前世今生、灵魂使命感兴趣的朋友，以及希望从深层次了解人生困境根源、寻求深刻疗愈与转化的人群。',
      item1: '对前世今生、灵魂使命与生命意义有强烈探索欲望的人',
      item2: '面临反复出现的人生困境，希望从根源找到答案与突破的人',
      item3: '有莫名的恐惧、身体症状或情绪模式，怀疑与前世有关的人',
      item4: '渴望与高我建立深度连接，获得灵魂层面指引与疗愈的人',
      item5: '母语面对面沟通，无远程，只限中文客户',
    },
    method: {
      title: '疗愈方式',
      step1: { title: '深度催眠引导', desc: '通过专业的语言引导与放松技术，帮助您安全进入深层潜意识状态，全程在疗愈师陪伴下进行' },
      step2: { title: '潜意识探索对话', desc: '在催眠状态下，与潜意识及高我进行深度对话，探索前世记忆、灵魂使命与当前课题的根源' },
      step3: { title: '疗愈整合与唤醒', desc: '在高我智慧的引导下完成深层疗愈，温和唤醒后进行体验整合，提供详细的后续指导建议' },
    },
    cta: { title: '开启您的量子催眠之旅', button: '立即预约量子催眠', back: '返回服务列表' },
    pricing: {
      title: '服务时长与费用',
      duration: '服务时长',
      price: '服务费用',
      note: '量子催眠时长因个人情况而异，建议预留充足时间。如需了解更多，欢迎联系我们',
      items: [
        { duration: '3 – 4 小时', price: 'SGD $450', label: '完整催眠疗愈' },
      ],
    },
    qhhtSection: {
      overview: {
        tag: '关于 QHHT',
        title: '什么是量子疗愈催眠技术（QHHT）',
        content: '量子疗愈催眠技术（QHHT）由多洛雷斯·坎农（Dolores Cannon）创立，是一种特殊的催眠方法，它引导客户进入深度θ脑波状态，从而获取前世记忆或其他意识体验。其目标是与客户的"高我"连接，以获得洞察力、明确人生目标，并促进身心疗愈。',
      },
      elements: {
        title: 'QHHT 的关键要素',
        items: [
          { icon: 'ri-user-star-line', title: '创始人', desc: '由多洛雷斯·坎农（Dolores Cannon）在45余年的实践中发展而来。' },
          { icon: 'ri-eye-line', title: '潜意识／高我', desc: 'QHHT 与坎农所称的"潜意识"互动——她将其定义为无限的、全知的自我部分，蕴含着前世信息，并能促进即时疗愈。' },
          { icon: 'ri-time-line', title: '疗程结构', desc: '典型疗程持续4-5小时，包括对客户生活经历的访谈、催眠过程以及对疗程结果的回顾。' },
          { icon: 'ri-brain-line', title: 'θ脑波状态', desc: '运用视觉化技巧达到深度放松的θ脑波状态——通常在入睡或醒来之前体验到。' },
          { icon: 'ri-history-line', title: '前世回溯（PLR）', desc: 'QHHT 允许高我选择最合适的体验，可能是前世、另一个维度，或是另一个星球上的场景。' },
        ],
      },
      benefits: {
        title: '潜在益处',
        items: [
          { icon: 'ri-heart-pulse-line', title: '身心疗愈', desc: '引导高我进行身体扫描，以识别并疗愈身体问题。' },
          { icon: 'ri-compass-3-line', title: '人生目标洞察', desc: '清晰了解个人选择当前人生境遇的原因，并理解人生课题。' },
          { icon: 'ri-shield-flash-line', title: '克服恐惧', desc: '解决恐惧、恐惧症和障碍，包括对死亡的恐惧。' },
          { icon: 'ri-links-line', title: '人际关系清晰度', desc: '理解业力关系和人生挑战。' },
        ],
      },
      preparation: {
        title: '疗愈准备',
        content: '建议您休息充足，为长时间的疗程做好充分准备。',
      },
    },
  },
  oracleDetail: {
    hero: {
      title: '神谕卡',
      subtitle: '神圣智慧与直觉引导',
      description: '借助神谕卡的神圣智慧与直觉引导，为您当下的生命议题带来清晰的洞见与指引，连接内在智慧，找到前行的方向与力量。',
    },
    intro: {
      title: '什么是神谕卡',
      content: '神谕卡是一种古老的灵性工具，它通过神圣的符号、图像与文字，传递来自高我、宇宙与内在智慧的讯息。每一张卡片都蕴含着深刻的灵性智慧与直觉指引，能够为您当下的生命议题带来清晰的洞见与方向。',
    },
    benefits: {
      title: '核心功效',
      benefit1: { title: '清晰洞见', description: '为当下的生命议题带来清晰的洞见与理解' },
      benefit2: { title: '直觉连接', description: '强化直觉力，连接内在智慧与高我指引' },
      benefit3: { title: '方向指引', description: '在迷茫时获得方向，找到前行的道路' },
      benefit4: { title: '内在力量', description: '唤醒内在力量与勇气，面对生命挑战' },
      benefit5: { title: '灵性成长', description: '通过卡片讯息，获得灵性成长的启发与指引' },
      benefit6: { title: '当下觉察', description: '提升对当下的觉察力，看清生命的真相' },
    },
    process: {
      title: '解读流程',
      step1: { title: '意图设定', description: '明确您想要探索的生命议题或寻求指引的问题' },
      step2: { title: '抽卡解读', description: '在放松状态下抽取卡片，接收神圣讯息' },
      step3: { title: '深度解析', description: '结合直觉与灵性智慧，深度解析卡片讯息' },
      step4: { title: '整合应用', description: '将卡片指引整合到生活中，找到实践的方向' },
    },
    suitable: {
      title: '适合人群',
      content: '适合所有在人生十字路口、面临重要决策、感到迷茫困惑的朋友，以及希望连接内在智慧、提升直觉力、寻求灵性指引的人群。',
      item1: '面临重要人生决策（职业、感情、人生方向）需要清晰指引的人',
      item2: '感到迷茫困惑，希望获得来自内在智慧与宇宙的讯息与支持的人',
      item3: '希望提升直觉力、加深与高我连接、开启灵性成长的探索者',
      item4: '需要情感支持与心灵疏导，寻求温暖而有深度的灵性陪伴的人',
    },
    method: {
      title: '疗愈方式',
      step1: { title: '意图设定与能量调频', desc: '在解读开始前，引导您明确内心议题，通过冥想与呼吸调整能量频率，为接收神圣讯息做好准备' },
      step2: { title: '直觉抽卡与牌阵解读', desc: '根据您的议题选择合适的牌阵，在放松状态下直觉抽卡，结合卡片图像与符号进行深度解读' },
      step3: { title: '洞见整合与行动指引', desc: '将卡片讯息与您的实际生活情境相结合，提供具体可行的洞见与行动建议，帮助您落实改变' },
    },
    cta: { title: '开启您的神谕卡之旅', button: '立即预约神谕卡解读', back: '返回服务列表' },
    pricing: {
      title: '服务时长与费用',
      duration: '服务时长',
      price: '服务费用',
      note: '如需了解更多详情或特别安排，欢迎通过 WhatsApp 联系我们',
      items: [
        { duration: '15 分钟', price: 'SGD $40', label: '单一议题解读' },
        { duration: '30 分钟', price: 'SGD $60', label: '深度全面解读' },
      ],
    },
  },
  chakraDetail: {
    hero: {
      title: '脉轮测试',
      subtitle: '能量中心评估与平衡',
      description: '通过系统评估七大脉轮能量中心的状态，精准定位能量阻塞与失衡点，深入了解身体、情绪与灵性的内在关联，开启全面的自我认知与疗愈之旅。',
    },
    intro: {
      title: '什么是脉轮测试',
      content: '脉轮（Chakra）是人体中七个主要的能量中心，从脊柱底部延伸至头顶，每个脉轮对应不同的身体部位、情绪状态与灵性层面。脉轮测试通过专业的能量评估方法，系统检测每个脉轮的开放程度与能量流动状态，找出阻塞或过度活跃的能量中心，帮助您深入了解自身的身心灵状况，并提供针对性的疗愈建议与方案。',
    },
    benefits: {
      title: '核心功效',
      benefit1: { title: '精准评估', description: '系统检测七大脉轮能量状态，找出失衡与阻塞点' },
      benefit2: { title: '深层自知', description: '了解每个脉轮对应的情绪、行为模式与生命课题' },
      benefit3: { title: '定向疗愈', description: '根据测试结果，制定个性化的针对性疗愈方案' },
      benefit4: { title: '能量平衡', description: '通过疗愈引导，逐步恢复脉轮之间的和谐流动' },
    },
    suitable: {
      title: '适合人群',
      item1: '对自身能量状态感到困惑，希望深入了解身心灵内在关联的人',
      item2: '长期有不明原因的身体不适、情绪波动或生活困境，寻求根源探索的人',
      item3: '刚开始灵性探索之旅，希望通过系统评估找到疗愈切入点的人',
      item4: '已有疗愈经验，希望更精准了解自身能量状态以深化疗愈的人',
      item5: '对能量医学、脉轮系统感兴趣，想要体验系统性评估的探索者',
    },
    method: {
      title: '测试方式',
      step1: { title: '深度问卷评估', desc: '通过涵盖身体、情绪、思维与灵性各层面的专业问卷，系统收集七大脉轮的状态信息' },
      step2: { title: '能量扫描解读', desc: '结合直觉感知与能量评估技术，对每个脉轮进行深度解读，识别失衡模式与根源成因' },
      step3: { title: '个性化报告与建议', desc: '整合评估结果，生成详细的脉轮能量报告，并提供具体可行的疗愈建议与后续方案' },
    },
    chakras: {
      title: '七大脉轮',
      items: [
        { name: '海底轮', color: '安全感', description: '根基与安全感、生存本能与物质稳定' },
        { name: '脐轮', color: '创造力', description: '情感流动、创造力与人际关系' },
        { name: '太阳神经丛', color: '意志力', description: '个人力量、自信心与行动力' },
        { name: '心轮', color: '爱', description: '爱的能力、同理心与内心和谐' },
        { name: '喉轮', color: '表达', description: '真实表达、沟通能力与创意表现' },
        { name: '眉心轮', color: '直觉', description: '直觉力、洞察力与内在智慧' },
        { name: '顶轮', color: '灵性', description: '灵性连接、宇宙意识与更高智慧' },
      ],
    },
    cta: { title: '开启您的脉轮探索之旅', button: '立即预约脉轮测试', back: '返回服务列表' },
    pricing: {
      title: '服务时长与费用',
      note: '如需了解更多详情或特别安排，欢迎通过 WhatsApp 联系我们',
      items: [
        { duration: '15 分钟', price: 'SGD $30', label: '脉轮快速评估' },
        { duration: '30 分钟', price: 'SGD $60', label: '脉轮深度解读' },
        { duration: '60 分钟', price: 'SGD $100', label: '测试+初步疗愈引导' },
      ],
    },
  },
  healer: {
    eyebrow: '关于疗愈师',
    title: '与您同行的灵性引导者',
    name: 'Susie',
    role: '认证灵性疗愈师 · 新加坡',
    bio: 'Susie 拥有超过5年的灵性疗愈经验，精通 PELLOWAH、UMANA、巴赫花精、量子催眠与神谕卡等多种疗愈体系。她以温暖、专业、直觉敏锐著称，曾陪伴数百位来访者走过人生的迷茫与困境，帮助他们重新找回内在的平静与力量。她相信每个人内心都拥有疗愈自己的智慧，而她的使命是成为那道温柔的阳光，引导您回归真实的自我。',
    yearsNum: '5+',
    yearsLabel: '年疗愈经验',
    credentialsTitle: '专业认证与资历',
    credentials: [
      'PELLOWAH 能量疗愈国际认证导师',
      'UMANA 整合疗愈系统认证从业者',
      '巴赫花精疗愈国际注册治疗师（BFRP）',
      '量子催眠深度疗愈（QHHT）认证从业者',
      '双语服务（中文 / 英文）',
    ],
    qualities: [
      { icon: 'ri-heart-line', title: '温暖陪伴', desc: '以同理心与温柔的方式，让您在安全的空间中被完全接纳' },
      { icon: 'ri-shield-check-line', title: '专业可信', desc: '多项国际认证背书，严格遵守职业伦理与保密原则' },
      { icon: 'ri-sparkling-line', title: '直觉敏锐', desc: '深厚的灵性修炼与丰富的实践经验，精准感知您的内在需求' },
    ],
  },
};
